import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_USER_STATUS } from './admin.reducer';

// Select the AvailableUserStatusesState - if we'll ever need this
// const availableUserStatusesStateSelector = (state: State<any>): AvailableUserStatusesState => (state as any).admin.availableUserStatuses;

// Select the actual list (not the AvailableUserStatusesState)
const availableUserStatusesSelector = (appState: any) => appState[STORE_FEATURE_USER_STATUS].statuses;

@Injectable()
export class AdminSelectors {
    constructor(private store: Store<any>) {
    }

    selectAvailableUserStatuses(): Observable<Array<any>> {
        return this.store
            .pipe(select(availableUserStatusesSelector));
    }
}
